'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_OrganizationInfoForm(name, address, email, website, aboutUs, certificateOfOriginAuthority, originalWatermark, copyWatermark) {
  this.s5 = null;
  this.s1 = null;
  this.s4 = null;
  this.s7 = null;
  this.s0 = null;
  this.s2 = null;
  this.s6 = null;
  this.s3 = null;
  this.s5 = name;
  this.s1 = address;
  this.s4 = email;
  this.s7 = website;
  this.s0 = aboutUs;
  this.s2 = certificateOfOriginAuthority;
  this.s6 = originalWatermark;
  this.s3 = copyWatermark;
}
export { $c_Lapp_data_OrganizationInfoForm as $c_Lapp_data_OrganizationInfoForm };
$p = $c_Lapp_data_OrganizationInfoForm.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_OrganizationInfoForm;
/** @constructor */
function $h_Lapp_data_OrganizationInfoForm() {
}
export { $h_Lapp_data_OrganizationInfoForm as $h_Lapp_data_OrganizationInfoForm };
$h_Lapp_data_OrganizationInfoForm.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_OrganizationInfoForm)) {
    if ((((((this.s5 === x$0.s5) && (this.s1 === x$0.s1)) && (this.s4 === x$0.s4)) && (this.s7 === x$0.s7)) && (this.s0 === x$0.s0))) {
      var x = this.s2;
      var x$2 = x$0.s2;
      var $x_2 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.s6;
      var x$4 = x$0.s6;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.s3;
      var x$6 = x$0.s3;
      return ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 8;
});
$p.t = (function() {
  return "OrganizationInfoForm";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.s5;
      break;
    }
    case 1: {
      return this.s1;
      break;
    }
    case 2: {
      return this.s4;
      break;
    }
    case 3: {
      return this.s7;
      break;
    }
    case 4: {
      return this.s0;
      break;
    }
    case 5: {
      return this.s2;
      break;
    }
    case 6: {
      return this.s6;
      break;
    }
    case 7: {
      return this.s3;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "address";
      break;
    }
    case 2: {
      return "email";
      break;
    }
    case 3: {
      return "website";
      break;
    }
    case 4: {
      return "aboutUs";
      break;
    }
    case 5: {
      return "certificateOfOriginAuthority";
      break;
    }
    case 6: {
      return "originalWatermark";
      break;
    }
    case 7: {
      return "copyWatermark";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_OrganizationInfoForm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jJ)));
}
export { $isArrayOf_Lapp_data_OrganizationInfoForm as $isArrayOf_Lapp_data_OrganizationInfoForm };
var $d_Lapp_data_OrganizationInfoForm = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_OrganizationInfoForm, "app.data.OrganizationInfoForm", ({
  jJ: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_OrganizationInfoForm as $d_Lapp_data_OrganizationInfoForm };
//# sourceMappingURL=app.data.-Organization-Info-Form.js.map
